import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FlyerStrip = () => {
  const [flyers, setFlyers] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/projects`)
      .then((res) => {
        const all = (res.data.projects || [])
          .filter((p) => p.flyers?.length)
          .flatMap((p) => p.flyers.map((f) => ({ ...f, slug: p.slug, project: p.title })));
        setFlyers(all);
      })
      .catch(() => {});
  }, []);

  if (!flyers.length) return null;

  return (
    <section data-testid="flyer-strip" className="py-24 md:py-36 border-t border-charcoal/10 overflow-hidden">
      <Reveal className="px-6 md:px-12 lg:px-24 mb-12 md:mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.34em] text-charcoal-mute mb-4">
            Flyers + Campaign
          </p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">
            The work <span className="italic text-chrome">in the world.</span>
          </h2>
        </div>
        <p className="max-w-xs text-sm text-charcoal-soft leading-relaxed md:text-right">
          Promotional systems in motion — events, campaigns, and live moments from the
          brand worlds.
        </p>
      </Reveal>

      <div className="marquee-pause relative overflow-x-auto md:overflow-hidden" aria-label="Flyer showcase">
        <div className="flex w-max gap-5 md:gap-8 px-6 md:px-12 animate-marquee" style={{ animationDuration: "70s" }}>
          {[...flyers, ...flyers].map((f, i) => (
            <Link
              key={`${f.src}-${i}`}
              to={`/work/${f.slug}`}
              data-testid={i < flyers.length ? `flyer-strip-item-${i}` : undefined}
              className="group block shrink-0"
              aria-hidden={i >= flyers.length}
              tabIndex={i >= flyers.length ? -1 : 0}
            >
              <img
                src={f.src}
                alt={`${f.project} — ${f.label}`}
                loading="lazy"
                className="block h-[340px] md:h-[440px] w-auto border border-charcoal/10 transition-transform duration-700 ease-out group-hover:scale-[1.02]"
              />
              <p className="mt-3 text-[10px] uppercase tracking-[0.24em] text-charcoal-mute group-hover:text-charcoal transition-colors duration-300">
                {f.project}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
